module.exports = __webpack_public_path__ + "img/scanVerificationCode.1845aa4a.png";